import { ReactNode } from 'react'
import { Navbar } from '@/app/entities/navbar/ui/Navbar'
import { Drawer } from '@/common/ui/Drawer'
import { Outlet } from 'react-router-dom'
import { ProfileMenu } from '@/app/entities/profileMenu/ui/ProfileMenu'
import { NavbarMobileMenu } from '@/app/entities/navbar/ui/Navbar'
import { ToastProvider, ToastViewport } from '@/common/ui/Toast/ToastProvider'
import { IncompleteProfileToastListener } from '@/common/entities/me/lib/IncompleteProfileToastListener'
import { SelectPortalRoot } from '@/common/ui/Form/Select'
import { PaymentResultModal } from '@/app/entities/paymentResult'

interface AppLayoutProps {
    children?: ReactNode
}

export const AppLayout = ({ children }: AppLayoutProps) => {
    return (
        <ToastProvider>
            <IncompleteProfileToastListener />
            <Drawer menu={<ProfileMenu topSlot={<NavbarMobileMenu />} />} id='my-drawer-1'>
                <div className='flex justify-center min-w-[370px]'>
                    <div className='min-h-screen max-w-7xl bg-base-100 flex-1 '>
                        <Navbar />
                        <main className='flex-1 flex flex-col min-h-0 lg:mx-0 py-[1.25rem] px-[1.25rem]'>
                            {children || <Outlet />}
                        </main>
                    </div>
                </div>
            </Drawer>
            <PaymentResultModal />
            <SelectPortalRoot />
            <ToastViewport />
        </ToastProvider>
    )
}

export default AppLayout
